module.exports = __webpack_public_path__ + "img/4.c3757058.jpg";